import {
  Typography,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

const cellSx = { fontWeight: 700, px: { xs: 0.5, sm: 2 }, whiteSpace: "nowrap", fontSize: { xs: "0.7rem", sm: "0.8125rem" } };
const bodySx = { px: { xs: 0.5, sm: 2 }, whiteSpace: "nowrap", fontSize: { xs: "0.7rem", sm: "0.8125rem" } };

export default function DashboardResumen({ store }) {
  if (store.resumenDiario.length === 0) return null;

  return (
    <Card variant="outlined" sx={{ mt: 3 }}>
      <CardContent sx={{ px: { xs: 1, sm: 2 }, "&:last-child": { pb: { xs: 1.5, sm: 2 } } }}>
        <Typography variant="subtitle1" fontWeight={700} mb={2}>
          Resúmenes Diarios
        </Typography>
        <TableContainer sx={{ mx: { xs: -1, sm: 0 }, width: { xs: "calc(100% + 16px)", sm: "100%" } }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={cellSx}>Fecha</TableCell>
                <TableCell align="center" sx={cellSx}>Leads</TableCell>
                <TableCell align="center" sx={{ ...cellSx, display: { xs: "none", sm: "table-cell" } }}>Contactos</TableCell>
                <TableCell align="center" sx={cellSx}>Convertidos</TableCell>
                <TableCell align="center" sx={cellSx}>Ventas</TableCell>
                <TableCell align="right" sx={cellSx}>Total</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {store.resumenDiario
                .sort((a, b) => b.fecha.localeCompare(a.fecha))
                .slice(0, 14)
                .map((r) => (
                  <TableRow key={r.id}>
                    <TableCell sx={bodySx}>{r.fecha.slice(5)}</TableCell>
                    <TableCell align="center" sx={bodySx}>{r.leadsNuevos}</TableCell>
                    <TableCell align="center" sx={{ ...bodySx, display: { xs: "none", sm: "table-cell" } }}>{r.contactosRealizados}</TableCell>
                    <TableCell align="center" sx={bodySx}>{r.inscritos}</TableCell>
                    <TableCell align="center" sx={bodySx}>{r.ventasCount}</TableCell>
                    <TableCell align="right" sx={{ ...bodySx, fontWeight: 700, color: "success.main" }}>
                      {store.config.moneda} {r.totalVentas.toLocaleString()}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
}
